// @flow
import React, { PureComponent } from 'react';
import Bulletin from 'components/hub/Bulletin';
import type { ListHomeCardType } from 'types/Settings';
import LazyLoad from 'components/fragments/LazyLoad';

export type Props = {
  title: string,
  cards: ListHomeCardType[]
};

class Participate extends PureComponent<Props> {
  renderParticipateElements() {
    const { cards } = this.props;
    return cards.map<any>((card, index) => (
      <Bulletin
        key={index}
        url={`/${card.parent_slug}/${card.object_slug}`}
        img={card.featured_image}
        title={card.title}
        description={card.description}
      />
    ));
  }

  render() {
    return (
      <section className="container section">
        <h2 className="mb-3">{this.props.title}</h2>
        <LazyLoad>
          <div className="row">{this.renderParticipateElements()}</div>
        </LazyLoad>
      </section>
    );
  }
}

export default Participate;
